import { render } from "./OrderInformation.vue?vue&type=template&id=f5dc81d4"
import script from "./OrderInformation.vue?vue&type=script&lang=js"
export * from "./OrderInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__